import { useCallback, useEffect, useRef, useState } from 'react';

import {
  CopyListItem,
  CopyLocale,
  lifecycleAPI,
  lifecycleErrorMessage,
} from '@/services/lifecycleAPI';

const useCopyList = (locale: CopyLocale) => {
  const [items, setItems] = useState<CopyListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  const silent = useRef(false);

  useEffect(() => {
    let active = true;
    if (!silent.current) setLoading(true);
    silent.current = false;
    setError(null);
    lifecycleAPI
      .listCopy({ locale })
      .then((result) => {
        if (active) setItems(result);
      })
      .catch((err) => {
        if (active) {
          setError(lifecycleErrorMessage(err, 'Could not load the messages.'));
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [locale, attempt]);

  const reload = useCallback(() => {
    silent.current = true;
    setAttempt((n) => n + 1);
  }, []);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  return { items, loading, error, reload, retry };
};

export default useCopyList;
